// extracted by mini-css-extract-plugin
export default {"shadowed":"RichContent_shadowed__DZTY-","richContent":"RichContent_richContent__jlmPO","loading":"RichContent_loading__fRfOP"};